import { unified } from "unified";
import remarkParse from "remark-parse";
import remarkGfm from "remark-gfm";
import remarkDirective from "remark-directive";
import type { Root } from "mdast";

/**
 * The one markdown parse in the client. Both the renderer (Markdown.tsx) and
 * the block editor (editor/blockDoc.ts) go through here, and it matters that
 * they share it: `remarkDirective` is what makes a whole `:::sidebyside … :::`
 * container a single top-level node, so the block editor treats a row as one
 * block instead of three unrelated ones.
 *
 * Kept apart from Markdown.tsx so the block model can be tested without
 * dragging in React and the viz registry.
 */
export const processor = unified()
  .use(remarkParse)
  .use(remarkGfm)
  .use(remarkDirective);

export function parseMarkdown(source: string): Root {
  return processor.parse(source) as Root;
}
